import { createAction, props } from '@ngrx/store';

import { ErrorDto } from '@platform/shared/error.model';

import { InboxDto } from './cockpit/inbox/inbox.model';
import { DocumentUploadHistoryDto } from './cockpit/inbox-upload-history/inbox-upload-history.model';
import { PortalTaskDocument } from './fiduciary.state';
import {
  PortalTaskCommentDto,
  PortalTaskDto,
  PostPortalTaskCommentDto,
  PostPortalTaskDto,
  PutPortalTaskDto,
  TaskOverviewDto,
} from './tasks/tasks.model';

export type Inbox = 'creditor' | 'payroll';

export const uploadFiduciaryInboxFiles = createAction(
  '[Fiduciary] Upload Fiduciary Inbox Files',
  props<{ customerSpaceId: string; targetInbox: Inbox; files: FileList }>(),
);

export const uploadFiduciaryInboxFilesSucceeded = createAction(
  '[Fiduciary] Upload Fiduciary Inbox Files Succeeded',
  props<{ targetInbox: Inbox }>(),
);

export const uploadFiduciaryInboxFilesFailed = createAction(
  '[Fiduciary] Upload Fiduciary Inbox Files Failed',
  props<{ targetInbox: Inbox; status: number; errors: ErrorDto }>(),
);

export const downloadFiduciaryInboxFile = createAction(
  '[Fiduciary] Download Fiduciary Inbox File',
  props<{ customerSpaceId: string; inbox: InboxDto; fileName: string; saveFileName: string }>(),
);

export const downloadFiduciaryInboxFileSucceeded = createAction(
  '[Fiduciary] Download Fiduciary Inbox File Succeeded',
  props<{ content: Blob }>(),
);

export const downloadFiduciaryInboxFileFailed = createAction(
  '[Fiduciary] Download Fiduciary Inbox File Failed',
  props<{ status: number; errors: ErrorDto }>(),
);

export const loadAllFiduciaryTasksForUser = createAction('[Fiduciary] Load All Tasks For User', props<{ customerSpaceId: string }>());

export const loadAllFiduciaryTasksForUserSucceeded = createAction(
  '[Fiduciary] Load All Tasks Succeeded For User',
  props<{ tasks: TaskOverviewDto[] }>(),
);

export const loadAllFiduciaryTasksForUserFailed = createAction(
  '[Fiduciary] Load All Tasks Failed For User',
  props<{ status: number; errors: ErrorDto }>(),
);

export const createTask = createAction(
  '[Fiduciary] Create Task',
  props<{ customerSpaceId: string; task: PostPortalTaskDto; files?: File[] | FileList }>(),
);

export const createTaskSucceeded = createAction('[Fiduciary] Create Task Succeeded', props<{ task: PortalTaskDto }>());

export const createTaskFailed = createAction('[Fiduciary] Create Task Failed', props<{ status: number; errors: ErrorDto }>());

export const updateTask = createAction(
  '[Fiduciary] Update Task',
  props<{ customerSpaceId: string; taskId: string; task: PutPortalTaskDto }>(),
);

export const updateTaskSucceeded = createAction('[Fiduciary] Update Task Succeeded', props<{ task: PortalTaskDto }>());

export const updateTaskFailed = createAction('[Fiduciary] Update Task Failed', props<{ status: number; errors: ErrorDto }>());

export const deleteTask = createAction('[Fiduciary] Delete Task', props<{ customerSpaceId: string; taskId: string }>());

export const deleteTaskSucceeded = createAction('[Fiduciary] Delete Task Succeeded');

export const deleteTaskFailed = createAction('[Fiduciary] Delete Task Failed', props<{ status: number; errors: ErrorDto }>());

export const loadTask = createAction('[Fiduciary] Load Task', props<{ customerSpaceId: string; taskId: string }>());

export const loadTaskSucceeded = createAction('[Fiduciary] Load Task Succeeded', props<{ task: PortalTaskDto }>());

export const loadTaskFailed = createAction('[Fiduciary] Load Task Failed', props<{ status: number; errors: ErrorDto }>());

export const loadTaskCommentsSucceeded = createAction(
  '[Fiduciary] Load Task Comments Succeeded',
  props<{ comments: PortalTaskCommentDto[] }>(),
);

export const loadTaskDocumentsSucceeded = createAction(
  '[Fiduciary] Load Task Documents Succeeded',
  props<{ documents: PortalTaskDocument[] }>(),
);

export const uploadDocument = createAction(
  '[Fiduciary] Upload Document',
  props<{ customerSpaceId: string; taskId: string; files: FileList }>(),
);

export const uploadDocumentSucceeded = createAction('[Fiduciary] Upload Document Succeeded', props<{ documents: PortalTaskDocument[] }>());

export const uploadDocumentFailed = createAction('[Fiduciary] Upload Document Failed', props<{ status: number; errors: ErrorDto }>());

export const deleteDocument = createAction(
  '[Fiduciary] Delete Document',
  props<{ customerSpaceId: string; taskId: string; documentId: string; showSuccessToast: boolean }>(),
);

export const deleteDocumentSucceeded = createAction('[Fiduciary] Delete Document Succeeded', props<{ documents: PortalTaskDocument[] }>());

export const deleteDocumentFailed = createAction('[Fiduciary] Delete Document Failed', props<{ status: number; errors: ErrorDto }>());

export const resetTaskDetail = createAction('[Fiduciary] Reset Task Detail');

export const resetTaskDocuments = createAction('[Fiduciary] Reset Task Documents');

export const createTaskComment = createAction(
  '[Fiduciary] Create Task Comment',
  props<{ customerSpaceId: string; taskId: string; comment: PostPortalTaskCommentDto }>(),
);

export const createTaskCommentSucceeded = createAction(
  '[Fiduciary] Create Task Comment Succeeded',
  props<{ comments: PortalTaskCommentDto[] }>(),
);

export const createTaskCommentFailed = createAction(
  '[Fiduciary] Create Task Comment Failed',
  props<{ status: number; errors: ErrorDto }>(),
);

export const deleteTaskComment = createAction(
  '[Fiduciary] Delete Task Comment',
  props<{ customerSpaceId: string; taskId: string; commentId: string }>(),
);

export const deleteTaskCommentSucceeded = createAction(
  '[Fiduciary] Delete Task Comment Succeeded',
  props<{ comments: PortalTaskCommentDto[] }>(),
);

export const deleteTaskCommentFailed = createAction(
  '[Fiduciary] Delete Task Comment Failed',
  props<{ status: number; errors: ErrorDto }>(),
);

export const loadInboxUploadHistory = createAction(
  '[Fiduciary] Load Inbox Upload History',
  props<{ customerSpaceId: string; inbox: InboxDto }>(),
);

export const loadInboxUploadHistorySucceeded = createAction(
  '[Fiduciary] Load Inbox Upload History Succeeded',
  props<{ histories: DocumentUploadHistoryDto[] }>(),
);

export const loadInboxUploadHistoryFailed = createAction(
  '[Fiduciary] Load Inbox Upload History Failed',
  props<{ status: number; errors: ErrorDto }>(),
);
